import React,{useState,useEffect} from "react";
import { Card, CardBody, DropdownToggle, DropdownMenu, DropdownItem, Table, UncontrolledDropdown } from "reactstrap"

import FeatherIcon from "feather-icons-react"
//Simple bar
import SimpleBar from "simplebar-react"
import axios from "../../axios"
import numeral from "numeral";
//Import Image
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import avatar2 from "../../assets/images/users/avatar-2.jpg"
import avatar4 from "../../assets/images/users/avatar-4.jpg"
import avatar5 from "../../assets/images/users/avatar-5.jpg"
import avatar6 from "../../assets/images/users/avatar-6.jpg"
import avatar7 from "../../assets/images/users/avatar-7.jpg"
import avatar8 from "../../assets/images/users/avatar-8.jpg"

const TopUser = () => {

    const [allusers, setallusers] = useState([])
    const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')

useEffect(() => {
    Gettopusers()
}, [])

    const Gettopusers = async() => {
        const get= await axios.instance.get('/Gettopusers',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
       
        }}).then((res) => {
        
       setallusers(res.data)
        })
        }
    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className="float-end">
                      
                    </div>
                    <h4 className="card-title mb-4">Top Customers</h4>
                    <SimpleBar style={{ maxHeight: "336px" }}>
                        <div className="table-responsive">
                            <Table className="table-borderless table-centered table-nowrap">
                                <tbody>
                                    {allusers.map((data,index)=>(
                                    <tr key={index}>
                                       {/* // <td style={{ width: "20px" }}><img src={avatar4} className="avatar-xs rounded-circle " alt="..." /></td> */}
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">{data.Customer_Name}</h6>
                                            <p className="text-muted font-size-13 mb-0">
                                                <i className="mdi mdi-map-marker"></i> {data.State}</p>
                                        </td>
                                        <td><span className="badge bg-soft-success font-size-12">Active</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />{numeral(data.Net_amount).format('0,0.00')}
                                        </td>
                                    </tr>
                                    ))}
                                  
                                </tbody>
                            </Table>
                        </div>
                    </SimpleBar>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default TopUser